import React, { useCallback } from 'react'
import ReactDOM from 'react-dom'
import cx from 'classnames'
import styles from '../../assets/stylesheets/pages/searches/pagination.module.scss'
import PropTypes from 'prop-types'

import { scrollToTop } from './search_page'

const PaginationControls = ({
  startIndex,
  endIndex,
  totalRecords,
  currentPage,
  totalPages,
  onNext,
  onPrevious
}) => {
  return (
    <div className={cx(styles['pagination--controls'])}>
      <a
        href='#previous_page'
        aria-label='Previous Page'
        className={cx(
          styles['pagination--mini-btn'],
          styles['pagination--previous'])}
        onClick={onPrevious}
        data-disabled={currentPage === 1}
      >
        <img src='/chevron-circle-left.svg' className={cx(styles['pagination--pagination-control-img'])} alt='' />
      </a>
      <div id='pagination-status' className={cx(styles['pagination--status'])}>
        <>
          <strong>{startIndex}</strong> - <strong>{endIndex}</strong> of <strong>{totalRecords}</strong>
        </>
      </div>
      <a
        href='#next_page'
        aria-label='Next Page'
        className={cx(
          styles['pagination--mini-btn'],
          styles['pagination--next'])}
        onClick={onNext}
        data-disabled={currentPage === totalPages}
      >
        <img
          src='/chevron-circle-right.svg'
          className={cx(styles['pagination--pagination-control-img'])} alt=''
        />
      </a>
    </div>
  )
}

PaginationControls.propTypes = {
  startIndex: PropTypes.number.isRequired,
  endIndex: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired
}

const Pagination = ({ currentPage, totalRecords, totalPages, recordsPerPage, setPageNumber, mountPoint }) => {
  const calcEndIndex = currentPage * recordsPerPage
  const startIndex = calcEndIndex - recordsPerPage + 1
  const endIndex = Math.min(calcEndIndex, totalRecords)

  const onNext = useCallback((event) => {
    event.preventDefault()

    if (event.target.dataset.disabled === 'true') return

    if (currentPage === 1) {
      // this is silly but...
      // we need to manually create a history entry that react is aware of for the back/forward button to work correctly
      history.replaceState({}, '', window.location.href)
    }

    if (currentPage < totalPages) {
      setPageNumber(() => {
        scrollToTop()
        return currentPage + 1
      })
    }
  }, [currentPage, totalPages, setPageNumber])

  const onPrevious = useCallback((event) => {
    event.preventDefault()

    if (event.target.dataset.disabled === 'true') return

    if (currentPage > 1) {
      setPageNumber(() => {
        scrollToTop()
        return currentPage - 1
      })
    }
  }, [currentPage, setPageNumber])

  // This component needs to be refactored when whole page is moved to react.
  // Then we could just position the component directly, without the need for `createPortal`.
  return ReactDOM.createPortal(
    <PaginationControls
      startIndex={startIndex}
      endIndex={endIndex}
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onNext={onNext}
      onPrevious={onPrevious}
    />,
    mountPoint
  )
}
Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  recordsPerPage: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  mountPoint: PropTypes.instanceOf(Element)
}

export default Pagination
